module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAABHNCSVQICAgIfAhkiAAAAOtJREFUSInVlN0NwjAMhL8gVqiabUgno52MsA3IQ4SHplVaOcSAQOLeEp19/tPBv8NJzwUITzgRx7W7MZaf4hlJnFqxTnqSvRwmABJnc8gi0N1xGkE8ISfcVprF9p2tcUvh0pMsXYgnLFzxetK9gPSkZge7oEvmDhYBgGMtSYlaQo2LY+puxOW5EcjzDq3qCmjcqXxsBLJyc1Qr3zDWgzXZu9BGpO1AP2Ht+hxDdQcZUfmrocnVdmAWsJzr13fw/wLrDp74UQRmc8sM8QQgGOwal33dbL8vwTG1Da5W7WzXsbz5jyGe0WLVP8UDK7hbwwA3wI0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/icon3ed.png
// module id = vZmg
// module chunks = 1